/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  font-size: 1.125em;
  font-weight: 400;
  display: inline-block;
  vertical-align: middle;
  max-width: 100%;
}

:host([small-font]) {
  font-size: 0.75em;
}

:host([interactive]) {
  cursor: pointer;
}

:host([as-button]) {
  background-color: var(--davinci-color-background-elements-6, );
  padding: 0 0.5rem;
}

:host .container {
  display: flex;
  align-items: center;
  height: 100%;
}
:host .container svg {
  flex-shrink: 0;
}
:host .container .item_label {
  white-space: nowrap;
  display: inline-block;
  flex: 1 1 auto;
  margin-left: 0.25em;
  margin-right: 0.25em;
  vertical-align: middle;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

:host([disabled]) .item_label {
  color: #8E989D;
  color: var(--davinci-color-outline, #8E989D);
}

:host([hidden]) {
  display: none;
}`;
export { style };
